module.exports = __webpack_public_path__ + "static/media/3.46cdf18f.jpg";